import { Component, OnInit, Input, Output, EventEmitter, SimpleChange } from '@angular/core';
import { IAddress } from 'src/app/shared/services/address.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ModalController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { ISaveCreditCardResponse, ICreditCardCvc, CreditCardService, ICreditCard } from '../../services/credit-card.service';
import { INumPadOptions, NumPadComponent } from 'src/app/shared/modals/num-pad/num-pad.component';

@Component({
    selector: 'account-credit-card-list',
    templateUrl: './credit-card-list.component.html',
    styleUrls: ['./credit-card-list.component.scss'],
    standalone: false
})
export class CreditCardListComponent implements OnInit {
  @Input() confirmCvc = false;
  @Input() legacy = false;
  @Input() storeId: string = '';
  @Output() onCardSelected: EventEmitter<ICreditCardCvc | ICreditCard> = new EventEmitter<ICreditCardCvc>();
  
  cvc: number;
  selectedCard: ICreditCard = null;
  cards: ICreditCard[] = [];
  loading: boolean = false;

  constructor(
    private creditCard: CreditCardService,
    private modalCtrl: ModalController,
    private loader: LoaderService) {
  }

  ngOnInit(): void {
    this.loadSavedCards();
  }

  getSavedCards(): ICreditCard[] {
    return this.cards;
  }

  selectFromSavedCard(savedCard: ISaveCreditCardResponse) {
    for (let card of this.cards) {
      if (card.Id != savedCard.id)
        continue;

      this.selectedCard = card;
      card.Cvn = savedCard.cvn;
      
      let eventModel: ICreditCardCvc = {
        Card: card,
        Cvc: savedCard.cvn
      };
  
      this.onCardSelected.emit(eventModel);
      break;
    }
  }

  async loadSavedCards(savedCard: ISaveCreditCardResponse = null) {
    const loader = await this.loader.create();
    this.loading = true;
    this.creditCard.getSavedCard({
      storeId: this.storeId
    })
    .pipe(finalize(async () => {
      if (savedCard != null)
        this.selectFromSavedCard(savedCard);

      await loader.dismiss();
      this.loading = false;
    }))
    .subscribe((savedCards) => {
      this.cards = savedCards;
    });
  }

  emptyCvns() {
    this.cards.forEach(t => {
      t.Cvn = null;
    });
  }

  async onCardSelectedEvent(card: ICreditCard) {
    this.selectedCard = card;

    if (this.confirmCvc) {
      let options: INumPadOptions = {
        title: "CreditCard.ConfirmCvn",
        inputText: "CreditCard.Cvn",
        buttonText: "General.Confirm"
      }

      const modal = await this.modalCtrl.create({
        component: NumPadComponent,
        componentProps: {
          options: options
        },
        //showBackdrop: true,
        cssClass: 'custom-border-modal-css'
      });

      modal.onDidDismiss()
        .then((response) => {
          if (!response.data) {
            this.unselectCard();
            return;
          }

          this.emptyCvns();

          this.cards.forEach(t => {
            if (card.Id == t.Id) {
              t.Cvn = response.data;
              return false;
            }
          });

          this.onCvcConfirmedEvent(card, response.data);
          return;
        });

      await modal.present();
    }

    this.onCardSelected.emit(card);
  }

  unselectCard() {
    this.emptyCvns();
    this.selectedCard = null;
    this.onCardSelected.emit(null);
  }

  onCvcConfirmedEvent(card: ICreditCard, cvc: number) {
    let eventModel: ICreditCardCvc = {
      Card: card,
      Cvc: cvc
    };

    this.onCardSelected.emit(eventModel);
  }

  async archiveCard(card: ICreditCard, e: Event){
    e.stopPropagation();
    const loader = await this.loader.create();
    this.loading = true;
    this.creditCard.archiveCard(card)
    .pipe(finalize(async () => {
      await loader.dismiss();
      this.loading = false;
        }))
    .subscribe(() => {
      this.cards = this.cards.filter(c => c.Id != card.Id)
    });
  }
}